var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "package_list" }, [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c(
          "el-image",
          {
            staticClass: "head_image",
            attrs: { src: _vm.value.config.head_image },
          },
          [
            _c(
              "div",
              { staticClass: "error", attrs: { slot: "error" }, slot: "error" },
              [_c("i", { staticClass: "el-icon el-icon-picture" })]
            ),
          ]
        ),
        _c(
          "div",
          {
            class: ["content", "content_" + _vm.value.config.show_type],
            style: { backgroundColor: _vm.value.config.background_colour },
          },
          [
            _vm.value.config.show_type === 1
              ? _vm._l(_vm.value.config.value, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "product" },
                    [
                      _c(
                        "el-image",
                        {
                          staticClass: "package_image",
                          attrs: { src: item.package_image, fit: "contain" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "error",
                              attrs: { slot: "error" },
                              slot: "error",
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon el-icon-picture",
                              }),
                            ]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "product_name" }, [
                        _vm._v(" " + _vm._s(item.package_name) + " "),
                      ]),
                      _c("div", { staticClass: "bottom" }, [
                        _c("div", { staticClass: "price_info" }, [
                          item.price_show
                            ? _c("div", { staticClass: "price" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("moneyFormat")(item.price_show)
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          item.platform_rate_show
                            ? _c("div", { staticClass: "platform_rate" }, [
                                _vm._v(
                                  " " + _vm._s(item.platform_rate_show) + " "
                                ),
                              ])
                            : _vm._e(),
                          item.platform_price_show
                            ? _c("div", { staticClass: "platform_price" }, [
                                _vm._v(
                                  " " + _vm._s(item.platform_price_show) + " "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        item.jd_comment_count_show
                          ? _c("div", { staticClass: "comment" }, [
                              _vm._v(" 京东评论："),
                              _c("span", { staticClass: "count" }, [
                                _vm._v(_vm._s(item.jd_comment_count_show)),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  )
                })
              : _vm._e(),
            _vm.value.config.show_type === 2
              ? _vm._l(_vm.value.config.value, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "product" },
                    [
                      _c(
                        "el-image",
                        {
                          staticClass: "package_image",
                          attrs: { src: item.package_image, fit: "contain" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "error",
                              attrs: { slot: "error" },
                              slot: "error",
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon el-icon-picture",
                              }),
                            ]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "product_name" }, [
                        _vm._v(" " + _vm._s(item.package_name) + " "),
                      ]),
                      _c("div", { staticClass: "bottom" }, [
                        _c("div", { staticClass: "price_info" }, [
                          _c("div", { staticClass: "info" }, [
                            item.price_show
                              ? _c("div", { staticClass: "price" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("moneyFormat")(item.price_show)
                                      ) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                            item.platform_rate_show
                              ? _c("div", { staticClass: "platform_rate" }, [
                                  _vm._v(
                                    " " + _vm._s(item.platform_rate_show) + " "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          item.platform_price_show
                            ? _c("div", { staticClass: "platform_price" }, [
                                _vm._v(
                                  " 京东：" +
                                    _vm._s(item.platform_price_show) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        item.jd_comment_count_show
                          ? _c("div", { staticClass: "comment" }, [
                              _c("div", [_vm._v(" 京东评论 ")]),
                              _c("div", { staticClass: "count" }, [
                                _vm._v(
                                  " " + _vm._s(item.jd_comment_count_show) + " "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  )
                })
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }